exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-config[data-v-6c860bc4] {\n  height: 100%;\n  overflow: auto;\n  width: 500px;\n  background: #fff;\n}\n.module-config header[data-v-6c860bc4] {\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n  border-bottom: 1px solid #f1f1f1;\n  font-size: 15px;\n  color: #333;\n}\n.module-config header span[data-v-6c860bc4] {\n  font-size: 12px;\n}\n", ""]);

// exports
